import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Field } from 'react-formality'
import { TextField } from '@material-ui/core'

import connectPropTypes from './utilities/connectPropTypes'
import handlerToCallUpdateIfValid from './utilities/Data/handlerToCallUpdateIfValid'
import getField from './utilities/Data/getField'
import Form from './components/Form'
import getFieldValueInUnit from './utilities/Data/User/getFieldValueInUnit'
import Img from './components/Img'
import DistanceUnitField from './components/Edit/DistanceUnitField'

import editStyles from './Edit.icss'

class EditWaist extends React.Component {
	constructor(props) {
		super(props)

		this.handlerToCallStatisticsUpdateIfValid = handlerToCallUpdateIfValid(props.userProfileStatisticsUpdate, { history: props.history })
		this.form = React.createRef()
		this.inputRef = React.createRef()
		this.scrollTimeout = null

		props.appShowBottomBar(false)
		props.appShowBottomNavBar(true)
		props.appBottomNavBarHandleClick(() => this.form.current.submit())
	}

	componentDidMount() {
		this.props.appHeading({ text: this.context.translate('Waist measurement') })
		this.props.appBottomNavBarLabelNext(this.context.translate('Done'))
	}

	render() {
		if (!this.props.user.userProfile) {
			return null
		}

		const statistics = getField(this.props.user, 'userProfile.statistics')

		return (
			<section>
				<div className={editStyles.pagePadding}>
					<Form
						ref={this.form}
						onSubmit={({ values, isValid }) => isValid && this.props.userProfileStatisticsUpdate({ values, goBack: true, history: this.props.history })}
						className={classNames(editStyles.oneColumn)}
						initialValues={{
							waist: getFieldValueInUnit(statistics, 'waist') || '',
							waistUnit: getField(statistics, 'waist.unit') || 'cm'
						}}
					>
						{(props) => {
							if (props.isValid === false) {
								this.inputRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' })
							}
							const handlerToCallStatisticsUpdateIfValid = this.handlerToCallStatisticsUpdateIfValid(props.store)
							return (
								<React.Fragment>
									<h2>{this.context.translate('Measure your waist')}</h2>
									<Img content="/images/content/guide/waist.svg" className={editStyles.img} />
									<p>
										{this.context.translate('Measure all the way around your waist at the height of your belly button with a flexible tape measure. Put two fingers under the tape to make sure the tape is not too tight.')}
									</p>
									<p>
										{this.context.translate('Alternatively give us the waist measurement of your favourite jeans.')}
									</p>
									<div className={editStyles.statistic}>
										<Field
											component={TextField}
											inputRef={this.inputRef}
											name="waist"
											className={editStyles.statisticValue}
											placeholder={props.values.waistUnit}
											label={this.context.translate('Waist')}
											value={props.values.waist}
											type="number"
											onBlur={handlerToCallStatisticsUpdateIfValid('waist', 'waistUnit')}
											validate={{
												presence: true,
												numericality: true
											}}
										/>
										<DistanceUnitField
											name="waistUnit"
											value={props.values.waistUnit}
											onBlur={handlerToCallStatisticsUpdateIfValid('waistUnit', 'waist')}
											onChange={props.store.setBinder('waistUnit')}
										/>
									</div>

								</React.Fragment>
							)
						}}
					</Form>
				</div>
			</section>
		)
	}
}

EditWaist.contextTypes = {
	translate: PropTypes.func
}

EditWaist.propTypes = {
	user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
	appBottomNavBarHandleClick: PropTypes.func.isRequired,
	appBottomNavBarLabelNext: PropTypes.func.isRequired,
	appHeading: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,
	appShowBottomNavBar: PropTypes.func.isRequired,
	userProfileStatisticsUpdate: PropTypes.func.isRequired,
	history: PropTypes.shape({
		goBack: PropTypes.func.isRequired
	}).isRequired
}

export default connectPropTypes(EditWaist)



// WEBPACK FOOTER //
// ./src/EditWaist.jsx